<template>
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true" :fullScreen="true">
    <div class="inputs px-2 pt-2">
        <div class="row mb-4">
            <div class="col-xl-1">
                <label for=""> <strong> Paciente: </strong></label>
            </div>
            <div class="col-xl-5">
                <input type="text" v-model="patient.name" class="form-control form-control-sm "  disabled >
            </div>
            <div class="col-xl-4">
               
            </div>
            <div class="col-xl-1">
                <label for=""> <strong> Margen: </strong></label>
            </div>
            <div class="col-xl-1">
                <input type="text" v-model="margen" class="form-control form-control-sm "  >
            </div>
        </div>
       
        <div class="table-container">
            <table class="table">
                <thead>
                    <tr>
                        <th colspan="4" class="header-ventas">ORDENES DE VENTA</th>
                        <th colspan="4" class="header-costo">COSTO</th>
                        <th colspan="3" class="header-utilidad">UTILIDAD</th>
                    </tr>
                    <tr>
                        <th>FECHA</th>
                        <th>ORDEN</th>
                        <th>DETALLE</th>
                        <th>MONTO</th>
                        <th>PROVEEDOR</th>
                        <th>FECHA</th>
                        <th>COMPROBANTE</th>
                        <th>COSTO</th>
                        <th>UTILIDAD NETA</th>
                        <th>UTILIDAD ESPERADA</th>
                        <th>DIFERENCIA</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tabla" :key="index">
                        <td v-if="shouldShowRowspan(index, 'date_order')" :rowspan="getRowspan(index, 'date_order')">
                            {{ item.date_order }}
                        </td>
                        <td v-if="shouldShowRowspan(index, 'order')" :rowspan="getRowspan(index, 'order')">
                            {{ item.order }}
                        </td>
                        <td class="highlight">{{ item.detalle }}</td>
                        <td>{{ item.monto }}</td>

                        <td v-if="shouldShowRowspan(index, 'proveedor')" :rowspan="getRowspan(index, 'proveedor')">
                            {{ item.proveedor }}
                        </td>
                        <td v-if="shouldShowRowspan(index, 'date_factura')" :rowspan="getRowspan(index, 'date_factura')">
                            {{ item.date_factura }}
                        </td>
                        <td v-if="shouldShowRowspan(index, 'numb_factura')" :rowspan="getRowspan(index, 'numb_factura')">
                            {{ item.numb_factura }}
                        </td>
                        <td>{{ item.price_cost }}</td>

                        <td class="bg-warning">{{ item.utilidad_neta }}</td>
                        <td class="bg-warning">{{ calcularUtilidadEsperada(item.price_cost) }}</td>
                        <td class="bg-danger">{{ calcularDiferencia(item.utilidad_neta, item.price_cost) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>

</CModal>

</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import CButtonClose from "@/components/shared/modals/cButtonClose.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";

export default {
    name: "c-vigilancia-modal-control",
    components: {
        CModal,
        CButtonClose,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            margen: 1 
        };
    },
    
  
    props: {
        title: String,
        boo_modal: Boolean,
        tabla:Array,
        patient:Object
       
    },
    methods: {
        ...mapActions(["get", "post"]),
       
        mtdclosemodal() {
            this.$emit("closeModalReport");
        },
        shouldShowRowspan(index, field) {
            return index === 0 || this.tabla[index][field] !== this.tabla[index - 1][field];
        },

        // Calcula cuántas filas necesita el rowspan
        getRowspan(index, field) {
            let count = 1;
            while (index + count < this.tabla.length && this.tabla[index][field] === this.tabla[index + count][field]) {
                count++;
            }
            return count;
        },
        calcularUtilidadEsperada(priceCost) {
            if (!this.margen || isNaN(this.margen)) {
                return priceCost; // Si el margen está vacío o no es un número, usa el costo original
            }
            return (parseFloat(priceCost) * parseFloat(this.margen)).toFixed(2);
        },
        calcularDiferencia(utilidadNeta, priceCost) {
            const utilidadEsperada = this.calcularUtilidadEsperada(priceCost);
            return (parseFloat(utilidadNeta) - parseFloat(utilidadEsperada)).toFixed(2);
        }
    },
};
</script>
<style scoped>
  .v-select{
    padding: 0px;
    border: 0px; 
     }
       .table-container {
        padding: 15px;
        background: #f8f9fa;
        border-radius: 10px;
    }

    .table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
        text-align: center;
    }

    thead th {
        padding: 10px;
        /* color: white; */
        border: 1px solid #ddd;
    }

    /* Colores de encabezados */
    .header-ventas { background: #7094ba; }
    .header-costo { background: #69bd7d; }
    .header-utilidad { background: #ffc107; color: #333; }

    tbody td {
        padding: 8px;
        border: 1px solid #ddd;
        background: #fff;
    }

    .bg-danger {
        background: #dc3545 !important;
        color: white;
        font-weight: bold;
    }

    .bg-warning {
        background: #f8c471 !important;
        color: #333;
        font-weight: bold;
    }

    .table-input {
        width: 60px;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 3px;
    }

    .highlight {
        background: #f2f2f2;
        font-weight: bold;
    }
</style>
